import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../../guards/auth-guard.service';
import {AdminBlogsComponent} from './admin-blogs.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.adminBlogs.pageInRouting,
    data: {data: PAGES_AND_PATHS.adminBlogs},
    component: AdminBlogsComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./admin-blogs.module').then(m => m.AdminBlogsModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminBlogsRoutingModule { }
